const LOCKED_BY_PRODUCT = 'error.app.player.locked.by.product.type';
const KYC_NOT_VERIFIED = 'error.app.player.locked.decline.restrictions';
const INSUFFICIENT_BALANCE =
  'error.app.player.locked.decline.restrictions.kyc.insufficient.balance';

export const FRONT_API_GATEWAY_ERROR_CODES = {
  LOCKED_BY_PRODUCT,
  KYC_NOT_VERIFIED,
  INSUFFICIENT_BALANCE,
};
